/* EVENTS */
export const GET_EXPENSE_CATEGORY = "GET_EXPENSE_CATEGORY";
export const GET_EXPENSE_CATEGORY_SUCCESS = "GET_EXPENSE_CATEGORY_SUCCESS";
export const GET_EXPENSE_CATEGORY_FAIL = "GET_EXPENSE_CATEGORY_FAIL";

export const ADD_NEW_EXPENSE_CATEGORY = "ADD_NEW_EXPENSE_CATEGORY";
export const ADD_EXPENSE_CATEGORY_SUCCESS = "ADD_EXPENSE_CATEGORY_SUCCESS";
export const ADD_EXPENSE_CATEGORY_FAIL = "ADD_EXPENSE_CATEGORY_FAIL";

export const UPDATE_EXPENSE_CATEGORY = "UPDATE_EXPENSE_CATEGORY";
export const UPDATE_EXPENSE_CATEGORY_SUCCESS = "UPDATE_EXPENSE_CATEGORY_SUCCESS";
export const UPDATE_EXPENSE_CATEGORY_FAIL = "UPDATE_EXPENSE_CATEGORY_FAIL";

// export const DELETE_EXPENSE_CATEGORY = "DELETE_EXPENSE_CATEGORY";
// export const DELETE_EXPENSE_CATEGORY_SUCCESS = "DELETE_EXPENSE_CATEGORY_SUCCESS";
// export const DELETE_EXPENSE_CATEGORY_FAIL = "DELETE_EXPENSE_CATEGORY_FAIL";


export const GET_EXPENSE_LIST = "GET_EXPENSE_LIST";
export const GET_EXPENSE_LIST_SUCCESS = "GET_EXPENSE_LIST_SUCCESS";
export const GET_EXPENSE_LIST_FAIL = "GET_EXPENSE_LIST_FAIL";

export const ADD_NEW_EXPENSE = "ADD_NEW_EXPENSE";
export const ADD_EXPENSE_SUCCESS = "ADD_EXPENSE_SUCCESS";
export const ADD_EXPENSE_FAIL = "ADD_EXPENSE_FAIL";

export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const UPDATE_EXPENSE_SUCCESS = "UPDATE_EXPENSE_SUCCESS";
export const UPDATE_EXPENSE_FAIL = "UPDATE_EXPENSE_FAIL";

 